import React from 'react';
import { Form } from '../../../ui/universe';
import { Radio, Tooltip } from 'tdesign-react';

/**
 * Radio 参数渲染器
 */
function RadioRenderer({ params, value, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <Radio.Group
        value={value}
        onChange={(e) => {
          const extra = params.options[params.options.findIndex((i) => i.value === e)];
          onChange && onChange(e, e, extra);
        }}
        className="unv-radio__group unv-radio__group--grid unv-radio__group--grid-3"
      >
        {params.options.map((op, index) => (
          <React.Fragment key={index}>
            <Radio value={op.value}>
              <span>{op.text}</span>
              {op.des && (
                <Tooltip content={op.des} theme="light">
                  <span className="ocrDemo-icon-question"></span>
                </Tooltip>
              )}
            </Radio>

          </React.Fragment>
        ))}
      </Radio.Group>
    </Form.Item>
  );
}

export default RadioRenderer;
